import { Resource as e } from "@coveo/platform-client";
//#region src/resources/MCPPipelinesResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/search/v2/admin/mcp/pipelines";
	}
	list(e) {
		return this.api.get(this.buildPath(t.baseUrl, {
			organizationId: this.api.organizationId,
			...e
		}));
	}
};
//#endregion
export { t as MCPPipelinesResource };

//# sourceMappingURL=MCPPipelinesResource.js.map